import { Utils } from "@/plugins/utils"
import router from "@/router"
import moment from "moment"

export default {
	namespaced: true,
	state: {
		lstMe9: [],
		lstFilling: [],
		lstReadingDocs: [],
		me9: {},
		of2: {},
		insert: false,
		update: false,
		loading: false,
		since: "",
		until: moment().format("YYYY-MM-DD 23:59"),
		itemsPerPage: 20,
		search: "",
		hasNext: false,
		lastUpdatedRegister: null,
		print: true,
        lstDuplicatedContainer: []
	},
	getters: {
		getUpdate(state) {
			return state.update
		},
		getMe9(state) {
			let me9 = { ...state.me9 }
			return me9
		},
		getSearch(state) {
			return state.search
		},
		getItemsPerPage(state) {
			return state.itemsPerPage
		},
		getLstFilling(state) {
			return state.lstFilling
		},
	},
	mutations: {
		set(state, me9) {
			state.me9 = me9
			if (me9) state.update = true
		},
		initForm(state) {
			state.insert = false
			state.update = false
			state.me9 = {}
		},
		setParamsDataTable(state, payload) {
			state.lstMe9 = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
		setLoading(state, loading) {
			state.loading = loading
		},
		setMe9(state, me9) {
			state.me9 = me9
		},
		setLstMe9(state, lstMe9) {
			state.lstMe9 = lstMe9
		},
		setHasNext(state, hasNext) {
			state.hasNext = hasNext
		},
		setSearch(state, search) {
			state.search = search
		},
		setLastUpdatedRegister(state, lastUpdatedRegister) {
			state.lastUpdatedRegister = lastUpdatedRegister
		},
		setLstFilling(state, lstFilling) {
			state.lstFilling = lstFilling.map(item => ({ ...item, meddata: moment(item.meddata).format("DD/MM/YYYY HH:mm") }))
		},
		setLstReadingDocs(state, lstReadingDocs) {
			state.lstReadingDocs = lstReadingDocs.map(item => ({
				...item,
				mecdhlei: moment(item.mecdhlei).format("DD/MM/YYYY HH:mm"),
			}))
		},
		setLstDuplicatedContainer(state, lstDuplicatedContainer) {
            state.lstDuplicatedContainer = lstDuplicatedContainer
        }
	},
	actions: {
		initForm({ commit }) {
			commit("initForm")
		},
		async find({ commit, dispatch }, me9idrecip) {
			commit("setLoading", true)
			commit("initForm")
			await this._vm.$axios
				.get(`/Oryxplace/ContainerRegistration/Find/${me9idrecip}`)
				.then(response => {
					let me9 = Utils.ValidateAxiosResponse(response.data)
					commit("set", me9)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
				})
			commit("setLoading", false)
		},
		async get({ dispatch }, me9idrecip) {
			return await this._vm.$axios
				.get(`/Oryxplace/ContainerRegistration/Find/${me9idrecip}`)
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return null
				})
		},
		async save({ getters, dispatch }) {
			if (getters.getUpdate) {
				return await dispatch("update")
			}
			return await dispatch("insert")
		},
		async insert({ commit, getters, dispatch }, me9model = null) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)

			const data = me9model || getters.getMe9

			let payload = await this._vm.$axios
				.post("/OryxPlace/ContainerRegistration/Insert", data)
				.then(response => {
					let me9 = Utils.ValidateAxiosResponse(response.data)
					commit("setLastUpdatedRegister", me9)
					commit("set", me9)
					return me9
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async update({ commit, getters, dispatch }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)
			let payload = await this._vm.$axios
				.put("/Oryxplace/ContainerRegistration/Update", getters.getMe9)
				.then(response => {
					commit("setLastUpdatedRegister", Utils.ValidateAxiosResponse(response.data))
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async delete({ getters, dispatch }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Excluindo", indeterminate: true },
				{ root: true },
			)
			await this._vm.$axios
				.delete(`/Oryxplace/ContainerRegistration/Delete/${getters.getMe9.me9idrecip}`)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					router.push("/oryxpdv/cadastro-de-recipientes")
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
		async search({ commit, getters, dispatch, state }, { limit = 20, page = 1 }) {
			commit("setLoading", true)
			commit("initForm")

			let url = `/Oryxplace/ContainerRegistration/Search?search=${getters.getSearch}&limit=${limit}&page=${page}`
			if (state.since) {
				url += `&since=${state.since}`
			}
			if (state.until) {
				url += `&until=${state.until}`
			}

			let payload = await this._vm.$axios
				.get(url)
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data)
					commit("setParamsDataTable", payload)
					return true
				})
				.catch(error => {
					commit("setLstMe9", [])
					commit("setSearch", "")
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			commit("setLoading", false)
			return payload
		},
		async findFillings({ commit, getters, dispatch }) {
			return await this._vm.$axios
				.get(`/Oryxplace/ContainerRegistration/FindFillings/${getters.getMe9.me9idrecip}`)
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data)
					commit("setLstFilling", payload)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return null
				})
		},
		async findReadingDocs({ commit, getters, dispatch }) {
			return await this._vm.$axios
				.get(`/Oryxplace/ContainerRegistration/FindReadingDocs/${getters.getMe9.me9idrecip}`)
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data)
					commit("setLstReadingDocs", payload)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return null
				})
		},
		async findRecipient({ state, dispatch }) {
			return await this._vm.$axios
				.get(`/Oryxplace/ContainerRegistration/FindRecipient`)
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return []
				})
		},
		async findRecipByCode({ dispatch }, idRecip) {
            return await this._vm.$axios.get(`/Oryxplace/ContainerRegistration/FindRecipByCode/${idRecip}`)
                .then(async response => {
                    let lstMe9 = Utils.ValidateAxiosResponse(response.data)

                    if (!lstMe9 || lstMe9.length === 0) {
                        throw new Error()
                    }   

                    if (lstMe9.length > 1) { 
                        await dispatch("me9/findByList", lstMe9.map(me9 => me9.me9idrecip), { root: true } )
                    }

                    return lstMe9
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: "Cilindro não encontrado"
                    }, { root: true })
                    return false
                });
        },
		async findByList({ commit, dispatch }, lstMeaIdRecips) {
            let payload = await this._vm.$axios.post("/OryxPlace/ContainerRegistration/FindByList", lstMeaIdRecips)
                .then(response => {
                    let lstMe9 = Utils.ValidateAxiosResponse(response.data)
                    commit("setLstDuplicatedContainer", lstMe9)
                    return lstMe9
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            return payload;
        },
		async getNewIdRecip({ dispatch }) {
			return await this._vm.$axios
				.get(`/Oryxplace/ContainerRegistration/GetNewIdRecip`)
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return []
				})
		},
		async validateManufacturerCode({ dispatch }, me9codfab) {
			return await this._vm.$axios
				.get(`/Oryxplace/ContainerRegistration/ValidateManufacturerCode?me9codfab=${me9codfab}`)
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return null
				})
		},
		async findLabelsToPrint({ dispatch }, params) {
			return await this._vm.$axios
				.post("/Oryxplace/ContainerRegistration/FindLabelsToPrint", params)
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
		},
		async printContainerLabel(store, params) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Imprimindo relatório", indeterminate: true },
				{ root: true },
			)
			let payload = await this._vm.$axios
				.post("/Oryxplace/ContainerRegistration/PrintContainerLabel", params)
				.then(async response => {
					const data = Utils.ValidateAxiosResponse(response.data)
					if (!!data) {
						await store.dispatch("print/openRelatsPath", [data], { root: true })
					}
					return data
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })

			return payload
		},
		async findByMe9codfab({ dispatch }, me9codfab) {
			return await this._vm.$axios
				.get(`/Oryxplace/ContainerRegistration/findByMe9codfab/${me9codfab}`)
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return null
				})
		},
		async findByMe9IdRecipandSupply(
			{ dispatch },
			{ me9idrecip, in9insumo }
		) {
			return await this._vm.$axios
				.get(`/Oryxplace/ContainerRegistration/findByMe9IdRecipandSupply/${me9idrecip}/${in9insumo}`)
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return null
				})
		},
		async findByMe9CodFabandSupply(
			{ dispatch },
			{ me9codfab, in9insumo }
		) {
			return await this._vm.$axios
				.get(`/Oryxplace/ContainerRegistration/findByMe9CodFabandSupply/${me9codfab}/${in9insumo}`)
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return null
				})
		},
	},
}
